/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import { createApi } from '@reduxjs/toolkit/query/react'
import sharedBaseQuery from '@redux/apis/sharedBaseQuery'

const api = createApi({
  reducerPath: 'api',
  baseQuery: sharedBaseQuery,
  endpoints: () => ({}),
})

export default api
